@if (product && !unCommerceApp) {
  <div class="add-to-cart-wrapper d-flex gap-2">
    <add-to-cart-btn class="w-50 h-100 position-relative" [addToCartText]="addToCartText" (action)="addToCart()" [quickBuy]="quickBuy" [redirectText]="redirectText" [continueText]="continueText"  [disabled]="maxQty == 0"></add-to-cart-btn>
    <!--    <a  [routerLink]="[product.getUrl()]" class="details-link d-lg-none" translate>See Full Details</a>-->
    <quantity-selector class="w-50 h-100 position-relative" [id]="product.product_id_i" [quantity]="product.fixed_lot_multiplier_i" (qtyChanged)="updateQty($event)" [value]="product.fixed_lot_multiplier_i" [minQty]="minQty" [maxQty]="maxQty" [mode]="mode"></quantity-selector>
  </div>
}

